import { z } from 'zod';
import { idSchema, dateSchema, emailSchema, urlSchema, optionalDateSchema, booleanSchema } from './common';

/**
 * USER API SCHEMAS
 * Guards against malformed user profile and identity responses.
 *
 * All fields use .catch(fallback) rather than .default(fallback) so that null,
 * undefined, and unexpected types from the API all safely resolve to the
 * fallback instead of throwing a parse error.
 */

export const careerGoalSchema = z.object({
  date: dateSchema,
  goal: z.string().catch('')
});

export const userProfileSchema = z.object({
  id: idSchema,
  name: z.string().catch('Unknown User'),
  email: z.string().catch(''),
  email2: emailSchema,
  type: z.string().optional().catch(undefined),
  clientId: idSchema,
  avatar: urlSchema,
  createdAt: optionalDateSchema,
  updatedAt: optionalDateSchema,
  linkedin: urlSchema,
  title: z.string().optional().catch(undefined),
  company: z.string().optional().catch(undefined),
  city: z.string().optional().catch(undefined),
  country: z.string().optional().catch(undefined),
  timezone: z.string().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  careerGoals: z.array(careerGoalSchema).catch([])
});

export type UserProfileResponse = z.infer<typeof userProfileSchema>;

// WHY: existence check feeds the onboarding flow — any payload the resilient boolean
// coercion cannot handle (objects, arrays) must fail closed to `false`, never throw.
export const userExistsSchema = booleanSchema.catch(false);
